import { render, staticRenderFns } from "./manageQuestionnaires.vue?vue&type=template&id=45e16327"
import script from "./manageQuestionnaires.vue?vue&type=script&lang=js"
export * from "./manageQuestionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports